import React, { useEffect, useState, useRef, useContext } from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import "rsuite/dist/rsuite.css";
import DoctorScheduleListBody from "../components/DataList/DoctorScheduleListBody";
import { useQuery } from "react-query";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import style from "../style/DoctorSchedule.module.scss";
import UploadExcel from "../components/UploadExcel";
import FakeApiClient from "../libraries/FakeApiClient";
import apiClient from "../libraries/ApiClient";
import Logger from "../libraries/Logger";
import dayjs from "dayjs";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 95%;
  height: calc(100% - 50px);
  color: #252525;
  position: relative;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .table {
    width: 100%;
    max-height: calc(100% - 246px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: 1200px) {
    .table {
      max-height: 100%;
      overflow-y: visible;
    }
    .pagination {
      position: static;
    }
  }
`;

function DoctorSchedule({ lineUserId }) {
  const navigate = useNavigate();
  const { myAuth } = useContext(AuthContext);
  const isAdmin = myAuth.IsAdmin;
  const permission = myAuth.AccountPermission;
  //console.log(isAdmin);
  const [selfIdentities, setSelfIdentities] = useState([]);
  useEffect(() => {
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
    // if (!isAdmin) {
    //   alert("您無此權限，為您轉到轉診清單頁");
    //   navigate("/ReferralDataList");
    // }
    if (permission != 1) {
      alert("您無此權限，為您轉到轉診清單頁");
      navigate("/ReferralDataList");
    }

    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    if (token === undefined) {
      navigate("/Login");
    }

    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, []);
  const { getValues, control } = useForm({
    defaultValues: {
      basic: "",
      case: [],
      date: [],
      transfer: [],
      open: false,
    },
  });

  const [open, setOpen] = useState(false);
  const [token, setToken] = useState("");
  const [nowPageNumber, setNowPageNumber] = useState(1);

  const [dateTime, setDateTime] = useState(new Date());
  const [month, setMonth] = useState(1);
  const [year, setYear] = useState(2023);

  const [excelFile, setExcelFile] = useState(null);

  useEffect(() => {
    setMonth(dateTime.getMonth() + 1);
    setYear(dateTime.getFullYear());
  }, []);

  const handlePageChange = (event, value) => {
    setNowPageNumber(value);
  };

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    if (JSON.parse(localStorage.getItem("auth")) === null || token === null) {
      navigate("/Login");
    }
  }, []);

  const sendDateData = async ({ queryKey }) => {
    //console.log(queryKey);
    const data = {
      Data: {
        Year: queryKey[2],
        Month: queryKey[3],
      },
    };
    //Logger.LogOfInfoWithIdentity("data=", data);

    const isFake = import.meta.env.VITE_FAKE_MODE;
    if (isFake === "false") {
      const result = await apiClient.postAes(
        "api/shift/GetShift/Security",
        data
      );
      //console.log(result);
      return result?.data?.Data;      
    }
  };

  const { data, refetch, isLoading } = useQuery(
    ["sendDateData", token, year, month],
    sendDateData,
    { refetchOnWindowFocus: false }
  );
  //console.log(data);

  const MonthDel = () => {
    if (month === 1) {
      setMonth(12);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
    refetch;
  };
  const MonthAdd = () => {
    if (month === 12) {
      setMonth(1);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
    refetch;
  };

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <Container isOpen={open}>
      <div className={style.top}>
        <div className={style.duty_month}>
          <a className={style.month_change}>
            <i className="fa-solid fa-chevron-left" onClick={MonthDel}></i>
          </a>
          <div className={style.month_info}>
            <span className={style.year}>{year}年</span>
            {month > 9 ? (
              <span className={style.month}>{month}月</span>
            ) : (
              <span className={style.month}>0{month}月</span>
            )}
          </div>
          <a className={style.month_change}>
            <i className="fa-solid fa-chevron-right" onClick={MonthAdd}></i>
          </a>
          值班
        </div>
        <div className={style.btn}>
          <div>
            <div className={style.duty_subtitle} style={{ marginTop: "8px" }}>
              上傳班表
              <span className={style.duty_notice}>{data?.LackOfSchedule}</span>
            </div>
            <table>
              <thead></thead>
              <tbody>
                <tr>
                  <td style={{ display: "flex", padding: "8px" }}>
                    <div>
                      <UploadExcel
                        size="small"
                        variant="contained"
                        setExcelFile={setExcelFile}
                        buttonText={month + "月"}
                        year={year}
                        month={month}
                      />
                    </div>
                    <div style={{ marginLeft: "16px" }}>
                      <UploadExcel
                        size="small"
                        variant="contained"
                        setExcelFile={setExcelFile}
                        buttonText={month === 12 ? 1 + "月" : month + 1 + "月"}
                        year={month === 12 ? year + 1 : year}
                        month={month === 12 ? 1 : month + 1}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <DoctorScheduleListBody data={data} />
    </Container>
  );
}

export default DoctorSchedule;
